export const appVersion = 'recurring-teacher@v2026.11.01.2307-820e5005';
